import React from 'react';
import styles from '../Assets/AboutBoutiqueSection.module.css';
import { useTranslation } from 'react-i18next';
import LocalizedLink from '../../../../Components/LocalizedLink';
import { FiChevronRight } from "react-icons/fi";

// Desktop Images
import bgEs from '../Assets/img/event/why-sp-banner.webp'; 
import bgEn from '../Assets/img/event/why-en-banner.webp'; 

// Mobile Images
import bgEsMobile from '../Assets/img/event/why-es-banner-mobile.webp'; 
import bgEnMobile from '../Assets/img/event/why-en-banner-mobile.webp'; 

import { Container } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

const AboutBoutiqueSection = () => {
    const { t, i18n } = useTranslation();

    // const activeLang = (i18n.resolvedLanguage || i18n.language || '').toLowerCase();
    // const isSpanish = activeLang.startsWith('es');


    // const currentDesktopBg = isSpanish ? bgEs : bgEn;
    // const currentMobileImg = isSpanish ? bgEsMobile : bgEnMobile;

    const currentBg = i18n.language && i18n.language.startsWith('es') ? bgEs : bgEn;
    const currentMobileBg = i18n.language && i18n.language.startsWith('en') ? bgEnMobile : bgEsMobile;

    return (
        <>
          
            {isMobile && (
                <div className={styles.mobileBannerWrapper}>
                    <img 
                        key={currentMobileBg}
                        src={currentMobileBg} 
                        alt="Manuel Spinosa" 
                        className="img-fluid w-100" 
                    />
                </div>
            )}

            <section
                className={styles.boutiqueWrapper}
                style={{ 
                    backgroundImage: isMobile ? 'none' : `url(${currentBg})` 
                }}
            >
                <Container fluid className="home-showcase-container">
                    <div className={styles.contentCol}>
                        {/* Top Gold Bar */}
                        <div className={styles.topAccentBar} />

                        {/* Main Section Heading */}
                        <h2 className={styles.mainTitle}>
                            {t('aboutBoutique.heading')}
                        </h2>

                        {/* Text Paragraphs */}
                        <div className={styles.textGroup}>
                            <p className={styles.paragraph}>{t('aboutBoutique.p1')}</p>
                            <p className={styles.paragraph}>{t('aboutBoutique.p2')}</p>
                            <p className={styles.paragraph}>{t('aboutBoutique.p3')}</p>
                        </div>

                        {/* Button with Arrow */}
                        <LocalizedLink to="/about" className={styles.linkWrapper}>
                            <button type="button" className={styles.readMoreBtn}>
                                <span>{t('aboutBoutique.button')}</span>
                                <FiChevronRight className={styles.btnIcon} />
                            </button>
                        </LocalizedLink>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default AboutBoutiqueSection;